import { FC } from "react";
// Redux
import { useAppSelector } from "hooks/useStore";
import { selectResult } from "store/player/playerSelectors";
import { selectQuiz } from "store/quiz/quizSelectors";
import IQuiz from "models/Quiz";
import IAnswer from "models/Answer";
// Components
import MarqueeText from "components/MarqueeText";
// Hooks
import useCompactLayout from "hooks/useCompactLayout";

interface Props {
  questionAnswers: IAnswer[];
  questionResults: any;
  allAnswers: number;
}

const AnswerList:FC<Props> = ({ questionAnswers, questionResults, allAnswers }) => {
  const isCompact = useCompactLayout();
  const result:any = useAppSelector(selectResult);
  const storeQuiz = useAppSelector(selectQuiz);
  const quiz:IQuiz | null = storeQuiz || result?.quiz || null;

  const topPercent = Math.max(...questionAnswers.map(answer => {
    const value = questionResults?.answers[answer.ref] || 0;
    return Number((value / allAnswers * 100).toFixed(2)) || 0;
  }));

  return (
    <div className={`flex flex-col flex-wrap ${isCompact ? 'h-full gap-x-4 gap-y-3 content-start overflow-hidden' : 'landscape:max-h-[500px] gap-x-6 gap-y-8'}`}>
      {questionAnswers.slice(0, 8).map((answer) => {
        const value = questionResults?.answers[answer.ref] || 0;
        const percent = Number((value / allAnswers * 100).toFixed(2)) || 0;

        const isTopPercent = percent === topPercent;
        const isFullWidth = questionAnswers.length < 5;

        return (
          <div
            key={answer.ref}
            className={`
              ${isFullWidth ? 'landscape:w-full' : 'landscape:w-[calc(50%-0.75rem)]'}
              shrink-0 shadow-primary-border rounded-md overflow-hidden
            `}
          >
            <div
              className={`
                flex justify-between items-center gap-2 px-4 py-2
                ${isTopPercent ? 'text-[#242324]' : ''}
              `}
              style={{ background: isTopPercent ? `linear-gradient(to right, ${quiz?.publicLeaderboard.primaryColor}, ${quiz?.publicLeaderboard.secondaryColor})` : (quiz?.publicLeaderboard?.backgroundColor || 'rgb(229,231,235,0.2)') }}
            >
              <div className="flex-1 overflow-hidden">
                <MarqueeText text={answer.title} compact={isCompact} />
              </div>

              <p className={`shrink-0 font-bold ${isCompact ? 'text-2xl' : 'text-md sm:text-3xl'}`}>{`${percent}%`}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
 
export default AnswerList;
